import { Button, Modal } from "@telluscompany/design-system";
import { useCreateModal } from "@shared/hooks";
import { DocumentUploadFormData } from "../../schemas";
import { useLocalization } from "@i18n";
import { UploadDocumentModal } from "./UploadDocumentModal";
import { useUploadPrivacyPolicyMutation } from "../../api";
import { DocumentViewer } from "@shared/components";
import { useUserContext } from "@/shared/contexts";

interface PrivacyPolicyTabProps {
  storagePath?: string;
  isFetching: boolean;
  isNotFound: boolean;
}

const PrivacyPolicyTab = ({
  storagePath,
  isNotFound,
}: PrivacyPolicyTabProps) => {
  const { translate } = useLocalization();
  const { modals, openCreate, closeCreate } = useCreateModal();
  const { mutate: upload, isPending } = useUploadPrivacyPolicyMutation();
  const { user } = useUserContext();
  const handleUpload = (formData: DocumentUploadFormData) => {
    upload({ file: formData.file[0] }, { onSuccess: closeCreate });
  };

  return (
    <div className="flex flex-col h-full p-4">
      <div className="flex justify-end mb-4">
        { user?.role === "owner" && (
        <Button variant="primary" onClick={openCreate} disabled={isPending}>
          {translate("management.privacyPolicy.button.addNewVersion")}
        </Button>
        )}
      </div>

      {isNotFound ? (
        <div className="flex-1 flex items-center justify-center text-sm text-muted-foreground">
          {translate("management.privacyPolicy.noFileUploaded")}
        </div>
      ) : (
        <DocumentViewer fileUrl={storagePath} />
      )}

      <Modal
        open={modals.create}
        content={
          <UploadDocumentModal onSubmit={handleUpload} onCancel={closeCreate} />
        }
        onClose={closeCreate}
        title={translate("management.privacyPolicy.modal.title.create")}
      />
    </div>
  );
};

export default PrivacyPolicyTab;
